export default {
  DRAW_SYMBOLS_POLYGONS: [
    { type: "simple-fill", style: "solid", color: [92, 92, 92] },
    { type: "simple-fill", style: "backward-diagonal" },
    { type: "simple-fill", style: "cross" },
    { type: "simple-fill", style: "vertical" },
    { type: "simple-fill", style: "forward-diagonal" },
    { type: "simple-fill", style: "horizontal" }
  ],
  DRAW_SYMBOLS_LINES: [
    {
      type: "simple-line",
      style: "solid",
      width: 1,
      color: [92, 92, 92, 1]
    },
    { type: "simple-line", style: "dot", width: 1, color: [92, 92, 92, 1] },
    {
      type: "simple-line",
      style: "dash",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "dash-dot",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "dot",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "long-dash",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "long-dash-dot",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "long-dash-dot-dot",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "short-dash",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "short-dash-dot",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "short-dash-dot-dot",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "short-dot",
      width: 1,
      color: [92, 92, 92, 1]
    },
    {
      type: "simple-line",
      style: "short-dot",
      width: 3,
      color: [92, 92, 92, 1]
    }
  ],
  DRAW_SYMBOLS_POINTS: [
    {
      type: "web-style",
      name: "Pushpin 3",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Pushpin 1",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Airport",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Circle",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Train",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "School",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Restaurant",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Pushpin 5",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Pushpin 4",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Pushpin 2",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },

    {
      type: "web-style",
      name: "Police",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Parking",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Diamond",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Diamond Wide",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Hexagon",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Border Crossing",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Bus",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Campground",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Octagon",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Rounded Square",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Square",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Star",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Centered Triangle",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "City Hall",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Coffee",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Ferry",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Fire",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Flag",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Hiking",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Hospital",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "House",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Industrial Complex",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Military Base",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Mountain",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "web-style",
      name: "Museum",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },

    {
      type: "web-style",
      name: "Park",
      portal: { url: "https://www.arcgis.com" },
      styleName: "EsriIconsStyle"
    },
    {
      type: "text",
      color: [0, 0, 0, 1],
      haloColor: "white",
      haloSize: "2px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 12
      }
    },
    {
      type: "text",
      color: [255, 0, 0, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 12
      }
    },
    {
      type: "text",
      color: [0, 153, 51, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 12
      }
    },
    {
      type: "text",
      color: [0, 0, 255, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 12
      }
    },
    {
      type: "text",
      color: [255, 255, 102, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 12
      }
    },
    {
      type: "text",
      color: [0, 0, 0, 1],
      haloColor: "white",
      haloSize: "2px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 20
      }
    },
    {
      type: "text",
      color: [255, 0, 0, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 20
      }
    },
    {
      type: "text",
      color: [0, 153, 51, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 20
      }
    },
    {
      type: "text",
      color: [0, 0, 255, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 20
      }
    },
    {
      type: "text",
      color: [255, 255, 102, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 20
      }
    },
    {
      type: "text",
      color: [0, 0, 0, 1],
      haloColor: "white",
      haloSize: "2px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 30
      }
    },
    {
      type: "text",
      color: [255, 0, 0, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 30
      }
    },
    {
      type: "text",
      color: [0, 153, 51, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 30
      }
    },
    {
      type: "text",
      color: [0, 0, 255, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 30
      }
    },
    {
      type: "text",
      color: [255, 255, 102, 1],
      haloColor: "white",
      haloSize: "1px",
      text: "Aa",
      xoffset: 0,
      yoffset: -3,
      font: {
        size: 30
      }
    }
  ]
};
